var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isLogin)?_c('Headers'):_vm._e(),(!_vm.isLogin)?_c('div',{staticClass:"main_container"},[_c('router-view')],1):_vm._e(),(!_vm.isLogin)?_c('Menu'):_vm._e(),(_vm.isLogin)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }